import { defineStore } from "pinia";

import { RecruitmentsService } from "@core/services";
import { RecruitmentDashboardModel } from "@core/models";
import {
  ACTION_RECRUITMENTS_GET_IN_PROGRESS,
  ACTION_RECRUITMENTS_GET_UPCOMING,
  ACTION_RECRUITMENTS_SET_SELECTED,
  ACTION_RECRUITMENTS_SET_SELECTED_EXTRA,
  ACTION_RECRUITMENTS_SOFT_REMOVE,
  GETTER_RECRUITMENTS_GET_IN_PROGRESS,
  GETTER_RECRUITMENTS_GET_SELECTED,
  GETTER_RECRUITMENTS_GET_SELECTED_EXTRA,
  GETTER_RECRUITMENTS_GET_SOFT_REMOVED,
  GETTER_RECRUITMENTS_GET_UPCOMING,
} from "@etab/stores/types";

export const useRecruitmentsStore = defineStore("recruitments", {
  // convert to a function
  state: () => ({
    inProgress: [],
    upcoming: [],
    selectedRecruimentId: undefined,
    selectedExtraId: undefined,
    softRemovedRecruitments: [],
  }),
  getters: {
    [GETTER_RECRUITMENTS_GET_IN_PROGRESS]: (state) => (state.inProgress || []).map((recruitment) => new RecruitmentDashboardModel(recruitment)),
    [GETTER_RECRUITMENTS_GET_UPCOMING]: (state) => (state.upcoming || []).map((recruitment) => new RecruitmentDashboardModel(recruitment)),
    [GETTER_RECRUITMENTS_GET_SELECTED]: (state) => state.selectedRecruimentId,
    [GETTER_RECRUITMENTS_GET_SELECTED_EXTRA]: (state) => state.selectedExtraId,
    [GETTER_RECRUITMENTS_GET_SOFT_REMOVED]: (state) => state.softRemovedRecruitments,
  },
  actions: {
    async [ACTION_RECRUITMENTS_GET_IN_PROGRESS]() {
      const recruitments = await RecruitmentsService.getAll({ current: 1 });
      this.inProgress = recruitments;
    },
    async [ACTION_RECRUITMENTS_GET_UPCOMING]() {
      const recruitments = await RecruitmentsService.getAll({ current: 0 });
      this.upcoming = recruitments;
    },
    [ACTION_RECRUITMENTS_SET_SELECTED](id) {
      this.selectedRecruimentId = id;
    },
    [ACTION_RECRUITMENTS_SET_SELECTED_EXTRA](id) {
      this.selectedExtraId = id;
    },
    [ACTION_RECRUITMENTS_SOFT_REMOVE](id) {
      this.softRemovedRecruitments.push(id);
    },
    // easily reset state using `$reset`
    clearRecruitmentsStore() {
      this.$reset();
    },
  },
});
